import React from 'react'

import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'

export interface FeedbackDescriptionProps {
  bodyText: string
}

export const FeedbackDescription: React.FC<FeedbackDescriptionProps> = ({ bodyText }) => {
  return (
    <Box style={{ padding: '8px 24px 8px 0px' }}>
      <P data-ui-test="feedback-description">{bodyText}</P>
    </Box>
  )
}
